/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { DESIGN_TOKEN } from "Config/design_token";

type FooterProps = React.PropsWithChildren<{}>;

function footer(props: FooterProps): JSX.Element {
  return (
    <footer
      css={css`
        display: flex;
        width: 100%;
        height: auto;
        margin: 0rem;
        padding: 2rem;
        align-items: ceneter;
        justify-content: center;
        flex-wrap: wrap;
        background-color: ${DESIGN_TOKEN.colors.swatch_1};
      `}
    >
      {props.children}
    </footer>
  );
}

const footerMemo = React.memo<FooterProps>(footer);
export { footerMemo as Footer };
